/**
 * localStorageをサポートしているか検証する
 * @returns localStorageをサポートしていればtrueを返却する
 */
export const localStorageAvailable = (): boolean | undefined => {
  let storage
  try {
    storage = window.localStorage
    const x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    )
  }
}
/**
 * ---  code の非奨励について ---
 * 2025年1月21日時点で非奨励案内はなし。（参考1⃣）
 * ただし、codeプロパティの mdn には非奨励記載があるが上記のほうが新しい。（参考2⃣）
 * 参考1⃣：https://developer.mozilla.org/ja/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
 * 参考2⃣：https://developer.mozilla.org/ja/docs/Web/API/DOMException/code
 */
